import React from "react";
import { LayoutGridIcon, PrinterIcon, ListChecksIcon, BoxIcon } from "lucide-react";
import { steps } from "../data/steps";
const stepIcons: BoxIcon[] = [LayoutGridIcon, PrinterIcon, ListChecksIcon];
export function HowItWorks() {
  return <section className="cube-grid relative border-t border-white/10 bg-navy-600" data-id="element-112" data-mp="3q02s4y2wk027">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-16 lg:py-20" data-id="element-113" data-mp="3u0v1drbry4yh">
        <div className="max-w-2xl" data-id="element-114" data-mp="lk0azbc5yd1a">
          <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-115" data-mp="ll1tu1zf83tk">
            Print. Play. Track. Repeat.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-116" data-mp="cshsuuvnpn5k">
            <span className="font-semibold text-white" data-id="element-117" data-mp="gtju1h94w9a6">Math Made Ready</span>{' '}
            gives every practice session a clear starting point, a visual
            challenge and an easy way to see progress.
          </p>
        </div>

        <ol className="relative mt-9 grid gap-5 sm:mt-11 sm:grid-cols-3 sm:gap-4" data-id="element-118" data-mp="19aw5whbx1ocr">
          {/* Connector rail */}
          <span aria-hidden="true" className="pointer-events-none absolute left-[26px] top-6 bottom-6 w-[2px] bg-brand-emerald/25 sm:left-6 sm:right-6 sm:top-[26px] sm:bottom-auto sm:h-[2px] sm:w-auto" data-id="element-119" data-mp="2rm7fesi2v9bd" />
          {steps.map((step, i) => {
          const Icon = stepIcons[i];
          return <li key={step.id} className="relative flex gap-4 border border-white/10 bg-navy-800/90 p-5 sm:flex-col sm:gap-0 sm:p-6" data-id="element-120" data-mp="2wjppwnbqtwlh" data-mpi={i}>
                <span className="relative z-10 flex h-[52px] w-[52px] shrink-0 items-center justify-center border-2 border-brand-emerald/70 bg-navy-900 text-brand-emerald" aria-hidden="true" data-id="element-121" data-mp="3ae8n8kcty9wx">
                  <Icon className="h-6 w-6" strokeWidth={2.25} data-id="element-122" data-mp="3k890xam6gnh9" />
                </span>
                <div className="sm:mt-5" data-id="element-123" data-mp="3fbs47s0wx0sk">
                  <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-124" data-mp="1pw2cha49wa70">
                    Step {step.index}
                  </p>
                  <h3 className="mt-2 font-pixel text-[11px] uppercase leading-relaxed tracking-[0.08em] text-white sm:text-xs" data-id="element-125" data-mp="1kz258vvot1eb">
                    {step.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-300" data-id="element-126" data-mp="3pz3ksgc6wojx">
                    {step.copy}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-8 text-sm font-medium text-brand-cyan sm:text-base" data-id="element-127" data-mp="2uncv1eyiuva">
          Less time searching for activities. More time spent actually
          practicing.
        </p>
      </div>
    </section>;
}